export enum UserActionTypeViewed {
  MailMessageViewed = 'MailMessageViewed'
}
